import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  addNotificationSuccess,
  addNotificationFailed,
  ADD_NOTIFICATION_START,
} from '~/views/app/redux/actions/notification'

/**
 * create notification api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const createNotificationApi = (params) => {
  const uri = `/notifications`
  return api.post(uri, params)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doCreateNotification(action) {
  try {
    const response = yield call(createNotificationApi, action?.payload)
    if (response?.statusCode !== 400) {
      yield put(addNotificationSuccess(response?.data))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response?.data)
      }
    } else {
      throw response?.message
    }
  } catch (error) {
    yield put(addNotificationFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch create notification request
 */
export default function* watchCreateNotification() {
  yield takeLatest(ADD_NOTIFICATION_START, doCreateNotification)
}
